/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useProfile from "../../hooks/useProfile";
import { CircularProgress } from "@mui/material";

const PrivateRoute = ({ children, ...rest }) => {
  const userId = localStorage.getItem("uI");
  const currentUser = userId - 786;
  let location = useLocation();

  const [userData, isLoading] = useProfile();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (currentUser !== -786) {
    return children;
  }
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
